import { keyBy } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { ModelCategory, ProjectLayoutModel } from '@paragon/contract-library';
import { getLayoutModels } from '@paragon/layout-models';

export const getProjects = createSelector(
  [getLayoutModels],
  (layoutModels) => layoutModels.filter((model) => model.category === ModelCategory.Project) as ProjectLayoutModel[],
);

export const getProjectsByGuid = createSelector(getProjects, (projects) => keyBy(projects, (project) => project.guid));

// Produces a map of component guid to component name for all loaded component designs
export const getComponentNames = createSelector([getLayoutModels], (layoutModels) => {
  const result: Record<string, string> = {};
  for (const model of Object.values(layoutModels)) {
    if (model.category === ModelCategory.ComponentDesign) {
      result[model.guid] = model.name;
    }
  }

  return result;
});
